import { useState } from "react";

export default function DemoDashboard() {
  const [hoveredNav, setHoveredNav] = useState(null);
  const [hoveredIssue, setHoveredIssue] = useState(null);
  const [hoveredTag, setHoveredTag] = useState(null);

  const navItems = [
    { id: "dashboard", label: "Dashboard", active: true },
    { id: "reports", label: "Reports", active: false },
    { id: "settings", label: "Settings", active: false },
    { id: "admin", label: "Admin", active: false },
  ];

  const colors = {
    bg: "#090B10",
    bgSoft: "#0D1117",
    bgPanel: "#10151D",
    bgPanel2: "#0F141B",
    bgSidebar: "#0B0E14",
    border: "rgba(255,255,255,0.06)",
    borderSoft: "rgba(255,255,255,0.04)",
    text: "#F5F7FA",
    textSoft: "#98A2B3",
    textMuted: "#667085",
    textDim: "#7B8190",
    orange: "#FF8A1E",
    orangeSoft: "rgba(255,138,30,0.12)",
    orangeBorder: "rgba(255,138,30,0.22)",
    green: "#22C55E",
    greenSoft: "rgba(34,197,94,0.10)",
    greenBorder: "rgba(34,197,94,0.18)",
    red: "#EF4444",
    redSoft: "rgba(239,68,68,0.12)",
    redBorder: "rgba(239,68,68,0.2)",
    blue: "#3B82F6",
    blueSoft: "rgba(59,130,246,0.16)",
  };

  const renderNavIcon = (id, isActive) => {
    const color = isActive ? colors.text : colors.textMuted;

    switch (id) {
      case "dashboard":
        return (
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <rect x="2" y="2" width="7" height="7" rx="2" fill={color} />
            <rect x="11" y="2" width="7" height="7" rx="2" fill={color} />
            <rect x="2" y="11" width="7" height="7" rx="2" fill={color} />
            <rect x="11" y="11" width="7" height="7" rx="2" fill={color} opacity="0.52" />
          </svg>
        );
      case "reports":
        return (
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <rect x="3" y="11" width="3.5" height="7" rx="1.2" fill={color} />
            <rect x="8.25" y="6" width="3.5" height="12" rx="1.2" fill={color} />
            <rect x="13.5" y="2" width="3.5" height="16" rx="1.2" fill={color} />
          </svg>
        );
      case "settings":
        return (
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round">
            <circle cx="10" cy="10" r="3" />
            <path d="M10 1.5v2.5M10 16v2.5M1.5 10H4M16 10h2.5M4.1 4.1l1.8 1.8M14.1 14.1l1.8 1.8M4.1 15.9l1.8-1.8M14.1 5.9l1.8-1.8" />
          </svg>
        );
      case "admin":
        return (
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 2L3 5.5v4.5c0 4.5 3 7.5 7 9 4-1.5 7-4.5 7-9V5.5L10 2z" />
            <path d="M7 10.5l2 2 4-4" />
          </svg>
        );
      default:
        return null;
    }
  };

  const AndroidBugIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M8 9.5h8c2.485 0 4.5 2.015 4.5 4.5v1.5a4.5 4.5 0 0 1-4.5 4.5H8A4.5 4.5 0 0 1 3.5 15.5V14A4.5 4.5 0 0 1 8 9.5Z"
        fill={colors.orange}
      />
      <path d="M9 6.5 7.5 4.5M15 6.5l1.5-2" stroke={colors.orange} strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="9.2" cy="13" r="0.9" fill={colors.bg} />
      <circle cx="14.8" cy="13" r="0.9" fill={colors.bg} />
    </svg>
  );

  return (
    <div
      style={{
        fontFamily:
          "'Inter', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        minHeight: "100vh",
        background: `linear-gradient(180deg, ${colors.bg} 0%, ${colors.bgSoft} 100%)`,
        display: "flex",
        color: colors.text,
      }}
    >
      <aside
        style={{
          width: 264,
          minHeight: "100vh",
          background: colors.bgSidebar,
          borderRight: `1px solid ${colors.borderSoft}`,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "28px 20px 26px",
            display: "flex",
            alignItems: "center",
            gap: 12,
            borderBottom: `1px solid ${colors.borderSoft}`,
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              background: colors.bgPanel,
              border: `1px solid ${colors.border}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <AndroidBugIcon />
          </div>
          <span
            style={{
              fontSize: 18,
              fontWeight: 700,
              letterSpacing: "-0.02em",
              color: colors.text,
            }}
          >
            BharatQA
          </span>
        </div>

        <nav style={{ flex: 1, padding: "14px 12px" }}>
          {navItems.map((item) => {
            const isHovered = hoveredNav === item.id;

            return (
              <button
                key={item.id}
                onMouseEnter={() => setHoveredNav(item.id)}
                onMouseLeave={() => setHoveredNav(null)}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "12px 14px",
                  marginBottom: 6,
                  border: `1px solid ${item.active ? colors.border : "transparent"}`,
                  borderRadius: 12,
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: item.active ? 600 : 500,
                  color: item.active ? colors.text : colors.textMuted,
                  background: item.active
                    ? colors.bgPanel
                    : isHovered
                      ? "rgba(255,255,255,0.02)"
                      : "transparent",
                  transition: "background 0.18s ease, border-color 0.18s ease, color 0.18s ease",
                  textAlign: "left",
                }}
              >
                {renderNavIcon(item.id, item.active)}
                {item.label}
              </button>
            );
          })}
        </nav>

        <div
          style={{
            padding: 16,
            borderTop: `1px solid ${colors.borderSoft}`,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: 12,
              borderRadius: 14,
              background: colors.bgPanel2,
              border: `1px solid ${colors.borderSoft}`,
            }}
          >
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                background: colors.orange,
                color: "#111418",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                fontWeight: 700,
              }}
            >
              F
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: colors.text,
                  lineHeight: 1.2,
                }}
              >
                Fund Up
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: colors.textMuted,
                  marginTop: 3,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                fundup3@gmail.com
              </div>
            </div>

            <button
              style={{
                background: "transparent",
                border: "none",
                color: colors.textMuted,
                cursor: "pointer",
                fontSize: 11,
                fontWeight: 500,
                padding: 0,
              }}
            >
              Sign out
            </button>
          </div>
        </div>
      </aside>

      <main
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "32px 40px 56px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 28,
          }}
        >
          <button
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "11px 18px",
              borderRadius: 12,
              border: `1px solid ${colors.border}`,
              background: colors.bgPanel2,
              color: colors.textSoft,
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            <span style={{ fontSize: 15, lineHeight: 1 }}>←</span>
            Back to Projects
          </button>

          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button
              style={{
                padding: "11px 16px",
                borderRadius: 12,
                border: `1px solid ${colors.border}`,
                background: colors.bgPanel2,
                color: colors.textSoft,
                fontSize: 14,
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
              }}
            >
              1 Day
              <span style={{ fontSize: 10, color: colors.textMuted }}>▼</span>
            </button>

            <button
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 10,
                padding: "11px 18px",
                borderRadius: 12,
                border: `1px solid ${colors.border}`,
                background: colors.bgPanel2,
                color: colors.text,
                fontSize: 14,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M8 10.5V2.5" />
                <path d="M5 5.5 8 2.5l3 3" />
                <path d="M3 11.5v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1" />
              </svg>
              Share Results
            </button>
          </div>
        </div>

        <section
          style={{
            background: colors.bgPanel,
            border: `1px solid ${colors.borderSoft}`,
            borderRadius: 24,
            padding: 32,
            marginBottom: 40,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 18,
              marginBottom: 28,
            }}
          >
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: 16,
                background: colors.blueSoft,
                border: `1px solid rgba(59,130,246,0.18)`,
                color: "#DCEBFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 20,
                fontWeight: 700,
              }}
            >
              U
            </div>

            <div>
              <h2
                style={{
                  fontSize: 22,
                  lineHeight: 1.1,
                  fontWeight: 700,
                  letterSpacing: "-0.03em",
                  margin: 0,
                  color: colors.text,
                }}
              >
                UClean
              </h2>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  flexWrap: "wrap",
                  marginTop: 8,
                  color: colors.textMuted,
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                <span>Created 17/03/2026</span>
                <span style={{ color: "#394150" }}>•</span>
                <span>2 Issues</span>
                <span style={{ color: "#394150" }}>•</span>
                <span
                  style={{
                    padding: "4px 12px",
                    borderRadius: 999,
                    background: colors.greenSoft,
                    border: `1px solid ${colors.greenBorder}`,
                    color: "#86EFAC",
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  Active
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              padding: "22px 24px",
              borderRadius: 18,
              background: colors.bgSoft,
              border: `1px solid ${colors.borderSoft}`,
              marginBottom: 28,
            }}
          >
            <div
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: colors.orange,
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                marginBottom: 12,
              }}
            >
              Instructions
            </div>

            <p
              style={{
                fontSize: 15,
                lineHeight: 1.7,
                color: colors.textSoft,
                margin: 0,
                fontWeight: 400,
              }}
            >
              1. Open the App. 2. Look Around. 3. Test the Environment. 4. Try to Break.
            </p>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              gap: 24,
              flexWrap: "wrap",
            }}
          >
            <div>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: colors.textSoft,
                  marginBottom: 12,
                }}
              >
                Targeting
              </div>

              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                {["WiFi Only", "Karnataka", "Hubballi"].map((tag) => (
                  <span
                    key={tag}
                    onMouseEnter={() => setHoveredTag(tag)}
                    onMouseLeave={() => setHoveredTag(null)}
                    style={{
                      padding: "8px 14px",
                      borderRadius: 10,
                      background:
                        hoveredTag === tag ? colors.bgPanel2 : "transparent",
                      border: `1px solid ${colors.border}`,
                      color: hoveredTag === tag ? colors.text : colors.textSoft,
                      fontSize: 13,
                      fontWeight: 500,
                      transition: "all 0.18s ease",
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  fontSize: 14,
                  color: colors.textSoft,
                  fontWeight: 500,
                }}
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: colors.green,
                    display: "inline-block",
                  }}
                />
                13 eligible testers
              </div>

              <button
                style={{
                  padding: "8px 16px",
                  borderRadius: 10,
                  border: `1px solid ${colors.border}`,
                  background: "transparent",
                  color: colors.textSoft,
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Edit
              </button>
            </div>
          </div>
        </section>

        <section>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 20,
            }}
          >
            <h2
              style={{
                fontSize: 18,
                fontWeight: 700,
                letterSpacing: "-0.02em",
                color: colors.text,
                margin: 0,
              }}
            >
              Reported Issues
            </h2>

            <span
              style={{
                minWidth: 28,
                height: 28,
                borderRadius: 10,
                background: colors.bgPanel,
                border: `1px solid ${colors.border}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                fontWeight: 700,
                color: colors.textSoft,
              }}
            >
              2
            </span>
          </div>

          <div
            style={{
              borderRadius: 22,
              background: colors.bgPanel,
              border: `1px solid ${colors.borderSoft}`,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 220px 140px 90px 36px",
                padding: "18px 28px",
                fontSize: 12,
                fontWeight: 700,
                color: colors.textMuted,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderBottom: `1px solid ${colors.borderSoft}`,
              }}
            >
              <span>Title</span>
              <span>Device</span>
              <span>Severity</span>
              <span>Time</span>
              <span></span>
            </div>

            <div
              onMouseEnter={() => setHoveredIssue(1)}
              onMouseLeave={() => setHoveredIssue(null)}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 220px 140px 90px 36px",
                padding: "22px 28px",
                alignItems: "center",
                borderBottom: `1px solid ${colors.borderSoft}`,
                background: hoveredIssue === 1 ? "rgba(255,255,255,0.015)" : "transparent",
                transition: "background 0.18s ease",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: colors.text,
                  lineHeight: 1.5,
                  paddingRight: 20,
                }}
              >
                Account deletion confirmation dialog loops upon reason selection
              </span>

              <span
                style={{
                  fontSize: 14,
                  color: colors.textSoft,
                  fontWeight: 400,
                }}
              >
                Samsung SM-J610F
              </span>

              <span>
                <span
                  style={{
                    padding: "6px 14px",
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                    background: colors.orangeSoft,
                    color: colors.orange,
                    border: `1px solid ${colors.orangeBorder}`,
                    display: "inline-flex",
                  }}
                >
                  High
                </span>
              </span>

              <span
                style={{
                  fontSize: 14,
                  color: colors.textMuted,
                  fontWeight: 500,
                }}
              >
                00:24
              </span>

              <span
                style={{
                  color: colors.textMuted,
                  fontSize: 12,
                }}
              >
                ▾
              </span>
            </div>

            <div
              onMouseEnter={() => setHoveredIssue(2)}
              onMouseLeave={() => setHoveredIssue(null)}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 220px 140px 90px 36px",
                padding: "22px 28px",
                alignItems: "center",
                background: hoveredIssue === 2 ? "rgba(255,255,255,0.015)" : "transparent",
                transition: "background 0.18s ease",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: colors.text,
                  lineHeight: 1.5,
                  paddingRight: 20,
                }}
              >
                User Profile Creation Data Integrity Flaws
              </span>

              <span
                style={{
                  fontSize: 14,
                  color: colors.textSoft,
                  fontWeight: 400,
                }}
              >
                INFINIX Infinix X6870
              </span>

              <span>
                <span
                  style={{
                    padding: "6px 14px",
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                    background: colors.redSoft,
                    color: "#FCA5A5",
                    border: `1px solid ${colors.redBorder}`,
                    display: "inline-flex",
                  }}
                >
                  Critical
                </span>
              </span>

              <span
                style={{
                  fontSize: 14,
                  color: colors.textMuted,
                  fontWeight: 500,
                }}
              >
                00:24
              </span>

              <span
                style={{
                  color: colors.textMuted,
                  fontSize: 12,
                }}
              >
                ▾
              </span>
            </div>
          </div>
        </section>
      </main>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

        * {
          box-sizing: border-box;
          margin: 0;
        }

        html, body, #root {
          background: ${colors.bg};
        }

        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        ::-webkit-scrollbar-track {
          background: transparent;
        }

        ::-webkit-scrollbar-thumb {
          background: rgba(255,255,255,0.08);
          border-radius: 999px;
        }

        ::-webkit-scrollbar-thumb:hover {
          background: rgba(255,255,255,0.14);
        }
      `}</style>
    </div>
  );
}
